@if (f) {
  <form [formGroup]="f" [ngClass]="{'form-submitted': formSubmitted}" (submit)="onSubmit()">
    <h2>{{ 'content.about-subject' | translate }}</h2>
    <h3>{{ 'content.person.name' | translate }}</h3>
    <div class="row">
      <div class="form-group col-md-4 pe-2">
        <label>{{ 'content.person.first-name' | translate }}
          <app-required [control]="c.firstName"></app-required>
          <input class="form-control" type="text" autocomplete="on" formControlName="firstName" #firstNameInput>
        </label>
        <app-validation-errors [displayErrors]="formSubmitted" [errors]="c.firstName.errors" [element]="firstNameInput"></app-validation-errors>
      </div>
      <div class="form-group col-md-4 pe-2">
        <label>{{ 'content.person.middle-name' | translate }}
          <app-required [control]="c.middleName"></app-required>
          <input class="form-control" type="text" autocomplete="on" formControlName="middleName" #middleNameInput>
        </label>
        <app-validation-errors [displayErrors]="formSubmitted" [errors]="c.middleName.errors" [element]="middleNameInput"></app-validation-errors>
      </div>
      <div class="form-group col-md-4 pe-2">
        <label>{{ 'content.person.last-name' | translate }}
          <app-required [control]="c.lastName"></app-required>
          <input class="form-control" type="text" autocomplete="on" formControlName="lastName" #lastNameInput>
        </label>
        <app-validation-errors [displayErrors]="formSubmitted" [errors]="c.lastName.errors" [element]="lastNameInput"></app-validation-errors>
      </div>
    </div>
    @if (enableIdentificationHeader) {
      <h3>{{ 'content.identification' | translate }}</h3>
    }
    <ng-content></ng-content>
    <h3>{{ 'content.current-address' | translate }}</h3>
    <app-address-form [displayErrors]="formSubmitted" [formGroup]="currentAddressF" (formGroup)="currentAddressF = $event"></app-address-form>
    @if (enablePreviousAddress) {
      <div class="col mb-2 ps-0 pe-0">
        <div class="form-check">
          <label class="form-check-label">
            <input class="form-check-input" type="checkbox" formControlName="inclPrevAddress">
            {{ 'content.address.previous-address' | translate }}
          </label>
        </div>
        @if (c.inclPrevAddress.value) {
          <div class="mt-2">
            <h3>{{ 'content.address.previous-address' | translate }}</h3>
            <app-address-form [displayErrors]="formSubmitted" [formGroup]="prevAddressF" (formGroup)="prevAddressF = $event"></app-address-form>
          </div>
        }
      </div>
    }
    @if (f.controls.phone) {
      <div>
        <h3>{{ 'content.phone.phone' | translate }}</h3>
        <app-phone-form-row phoneFormControlName="phone" phoneNumberCssClass="col-md-4" [displayErrors]="formSubmitted" [formGroup]="f"></app-phone-form-row>
      </div>
    }
    @if (enableEmployment) {
      <div>
        <h3>{{ 'content.employment' | translate }}</h3>
        <div class="row">
          <div class="form-group col-md-4 pe-2">
            <label>{{ 'content.person.occupation' | translate }}
              <app-required [control]="c.job"></app-required>
              <input class="form-control" type="text" autocomplete="on" formControlName="job" #jobInput>
            </label>
            <app-validation-errors [displayErrors]="formSubmitted" [errors]="c.job.errors" [element]="jobInput"></app-validation-errors>
          </div>
          <div class="form-group col-md-4 pe-2">
            <label>{{ 'content.employer' | translate }}
              <app-required [control]="c.employer"></app-required>
              <input class="form-control" type="text" autocomplete="on" formControlName="employer" #employerInput>
            </label>
            <app-validation-errors [displayErrors]="formSubmitted" [errors]="c.employer.errors" [element]="employerInput"></app-validation-errors>
          </div>
        </div>
      </div>
    }
    @if (additionalFormContent) {
      <div>
        <ng-container *ngTemplateOutlet="additionalFormContent"></ng-container>
      </div>
    }
    <div class="pe-0 d-flex justify-content-end inline-gap-5 submit-buttons">
      <button class="tu-button secondary tu-shadow" type="button" (click)="onBack()">{{ 'content.back' | translate }}</button>
      <button class="tu-button primary tu-shadow" type="submit">{{ 'content.next' | translate }}</button>
    </div>
  </form>
}
